import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import { register, load, getInstances } from '@shopify/theme-sections';
import * as Helper from '../utilities/helpers';
Avatar.theme = Avatar.theme || {};
Avatar.theme.sections = Avatar.theme.sections || {};
var sectionName = 'header';

Avatar.theme.sections.Header = function Header() {
  var selectors = {
    header: '[data-header]',
    headerNav: '[data-header-nav]',
    mobileMenuToggles: '[data-toggle="collapse"]',
    a11yDropdownTrigger: '[data-a11y-dropdown]',
    dropdown: '.nav-dropdown',
    intersect: '[data-intersect]'
  };
  var classes = {
    sticky: 'tw-sticky',
    top: 'tw-top-0',
    z: 'tw-z-10',
    negativeZ: 'tw--z-10',
    shadow: 'tw-shadow',
    translateY: 'tw--translate-y-full',
    hide: 'tw-hidden',
    pointerNone: 'tw-pointer-events-none'
  };
  register(sectionName, {
    onLoad: function onLoad() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var container;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                container = _this.container;
                _this.headerContainerParent = container.parentElement;
                _this.headerContainer = container;
                _this.intersect = document.querySelector(selectors.intersect);
                _this.header = container.querySelector(selectors.header);
                _this.headerNav = container.querySelector(selectors.headerNav);
                _this.mobileMenuToggles = container.querySelectorAll(selectors.mobileMenuToggles);
                _this.a11yDropdownTriggers = container.querySelectorAll(selectors.a11yDropdownTrigger);
                _this.eventHandlers = {};
                _this.settings = {};
                _this.collapses = [];
                _this.dropdowns = [];
                _this.scrollPosition = 0;
                _this.mqMediumUp = window.matchMedia(Avatar.theme.settings.mediaQuery.mediumUp);

                if (_this.headerContainer) {
                  _this.getSettings();
                }

                if (_this.settings.sticky) {
                  _this.initStickyHeader();

                  _this.eventHandlers.checkScrollDirection = Helper.throttle(_this.checkScrollDirection.bind(_this), 100);

                  _this.initScrollListener();

                  _this.mqMediumUp.onchange = _this.initScrollListener.bind(_this);
                }

                if (_this.a11yDropdownTriggers) {
                  _this.a11yDropdownTriggers.forEach(function (trigger) {
                    var submenu = trigger.parentElement.querySelector(selectors.dropdown);
                    var a11yDropdown = new Avatar.theme.A11yDropdown(trigger, submenu);

                    _this.dropdowns.push(a11yDropdown);
                  });
                }

                if (_this.mobileMenuToggles) {
                  _this.mobileMenuToggles.forEach(function (toggle) {
                    var target = toggle.dataset.target;
                    var menu = new Avatar.theme.Collapse(toggle, target);

                    _this.collapses.push(menu);
                  });
                }

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    getSettings: function getSettings() {
      this.settings = JSON.parse(this.container.getAttribute('data-section-settings'));
      return this.settings;
    },
    initStickyHeader: function initStickyHeader() {
      this.headerContainerParent.classList.add(classes.sticky, classes.top, classes.z);

      if (!this.mqMediumUp.matches) {
        this.header.classList.add(classes.shadow);
      }
    },
    checkScrollDirection: function checkScrollDirection() {
      var currentScroll = window.pageYOffset || document.documentElement.scrollTop;

      if (currentScroll < 1) {
        this.headerContainerParent.classList.remove(classes.shadow); // Need these if add back nav slide
        // this.showNav();
        // return;
      } else {
        // Don't need this else if add back nav slide
        this.headerContainerParent.classList.add(classes.shadow);
      } // Temporarily disable nav slide until we have better design/UX also check removeListener - 159
      // if (currentScroll > this.scrollPosition) {
      //   this.hideNav(currentScroll);
      // } else {
      //   this.showNav(currentScroll);
      // }

    },
    showNav: function showNav(currentScroll) {
      var _this2 = this;

      this.headerNav.classList.remove(classes.translateY, classes.pointerNone);
      this.header.classList.remove(classes.shadow);

      this.headerNav.ontransitionend = function () {
        _this2.headerNav.classList.remove(classes.negativeZ);

        if (currentScroll > 1) {
          _this2.headerContainerParent.classList.add(classes.shadow);
        }
      };

      this.scrollPosition = currentScroll <= 0 ? 0 : currentScroll;
    },
    hideNav: function hideNav(currentScroll) {
      var _this3 = this;

      this.headerNav.classList.add(classes.translateY, classes.negativeZ, classes.pointerNone);
      this.headerContainerParent.classList.remove(classes.shadow);

      this.headerNav.ontransitionend = function () {
        _this3.header.classList.add(classes.shadow);
      };

      this.scrollPosition = currentScroll <= 0 ? 0 : currentScroll;
    },
    initScrollListener: function initScrollListener() {
      if (this.mqMediumUp.matches) {
        window.addEventListener('scroll', this.eventHandlers.checkScrollDirection);
      } else {
        window.removeEventListener('scroll', this.eventHandlers.checkScrollDirection);
      }
    },
    onSelect: function onSelect() {},
    onDeselect: function onDeselect() {},
    onBlockSelect: function onBlockSelect() {},
    onBlockDeselect: function onBlockDeselect() {},
    onUnload: function onUnload() {
      // window.removeEventListener('scroll', this.eventHandlers.checkScrollDirection);
      this.collapses.forEach(function (collapse) {
        collapse.destroy();
      });
      this.dropdowns.forEach(function (dropdown) {
        dropdown.destroy();
      });
      Avatar.theme.PredictiveSearch.destroy();
      Avatar.theme.sections.AnnouncementBar.destroy();
    }
  });
  load(sectionName);
  var instance = getInstances(sectionName);
  return instance[0];
}();